'use client'

import {
  FormControl,
  FormDescription,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
} from '@/components/ui/form'
import { Input } from '@/components/ui/input'
import { Label } from '@/components/ui/label'
import ImageUploaderCrop from '@/helpers/image-uploader-crop'
import { ImagePlusIcon } from 'lucide-react'
import Image from 'next/image'
import { useRef, useState } from 'react'

export default function HeaderField({ form }) {
  const [currentImg, setCurrentImg] = useState()
  const [cropperOpen, setCropperOpen] = useState(false)
  const ref = useRef()

  return (
    <FormField
      control={form.control}
      name="headerImg"
      render={({ field: { onChange, value, ...fieldProps } }) => (
        <FormItem>
          <FormLabel>
            <h5 className="text-h-5-sm font-medium">
              Upload a Community Banner{' '}
              <span className="text-cap font-semibold">(Optional)</span>
            </h5>
          </FormLabel>
          <FormDescription className="text-p-2 text-neutral-blue-500">
            3mb max file size. 16:9 Ratio. File formats JPG, PNG, GIF.
          </FormDescription>
          <FormControl>
            <ImageUploaderCrop
              currentImg={ref.current?.files?.[0]}
              isOpen={cropperOpen}
              setIsOpen={setCropperOpen}
              setCurrentImg={(file) => {
                setCurrentImg(file)
                onChange(file)
                form.clearErrors('headerImg')
              }}
              aspectRatio={16 / 9}
              cropDescription="Please crop your image to a 16:9 ratio to ensure it displays correctly."
            >
              <Label onClick={() => ref.current?.click()} className="w-full">
                <div className="relative aspect-video w-full cursor-pointer overflow-hidden rounded-sm bg-neutral-blue-700 transition-all hover:bg-neutral-blue-800">
                  {currentImg ? (
                    <Image src={URL.createObjectURL(currentImg)} fill alt="" />
                  ) : (
                    <div className="flex h-full w-full flex-col items-center justify-center gap-3">
                      <ImagePlusIcon className="size-10 stroke-neutral-blue-500"></ImagePlusIcon>
                      Add image
                    </div>
                  )}
                </div>
              </Label>
              <Input
                {...fieldProps}
                type="file"
                accept="image/*"
                ref={ref}
                onChange={(e) => {
                  if (e.target.files?.[0]) {
                    setCropperOpen(true)
                    form.clearErrors('headerImg')
                  }
                }}
                className="hidden"
              ></Input>
            </ImageUploaderCrop>
          </FormControl>
          <FormMessage />
        </FormItem>
      )}
    />
  )
}
